import { NBSP, RUB } from '../../constants/common';
import { formatNumberWithSpaces } from './formatNumberWithSpaces';

export const formatNumberToMillionRubles = (num: number): string => {
  if (num >= 1000000) {
    const millions = num / 1000000;
    const formattedMillions = Number.isInteger(millions) ? millions : parseFloat(millions.toFixed(1));

    return `${formattedMillions}${NBSP}млн${NBSP}${RUB}`;
  }

  return `${formatNumberWithSpaces(num)}${NBSP}${RUB}`;
};
